import angular from "angular";
import floraService from './flora.service';

let floraModule = angular.module('flora.service', [])
.service('Flora', floraService)

.name;

export default floraModule;



// WEBPACK FOOTER //
// ./client/app/services/floraService/flora.js